<template>
  <div>
    <b-row class="mb-2 justify-content-between align-items-center">
  <b-col>
    <b-button variant="danger" @click="$router.go(-1)">Atrás</b-button>
  </b-col>
  <b-col class="text-right">
    <b-button variant="success" @click="saveLoan">Guardar</b-button>
  </b-col>
</b-row>

    <!-- Información del préstamo editable -->
    <b-row v-if="loan">
      <b-col sm="12">
        <b-card no-body>
          <b-card-header class="border-b-2 bg-secondary">
            <h4 class="text-white">Información del Préstamo (Editable)</h4>
          </b-card-header>
          <b-card-body class="mt-1">
            <b-row>
              <b-col sm="6" lg="3">
                <strong>Establecimiento Origen:</strong>
                <p class="mt-1">{{ loan.establishmentOrigin.name }}</p>
              </b-col>

              <b-col sm="6" lg="3">
                <b-form-group label="Cliente">
                  <v-select
                    :options="clients"
                    label="fullname"
                    v-model="loan.clientId"
                    :reduce="(client) => client.id"
                  />
                </b-form-group>
              </b-col>

              <b-col sm="6" lg="3">
                <b-form-group label="Documento">
                  <b-form-input v-model="loan.documentCode" placeholder="Documento" />
                </b-form-group>
              </b-col>

              <b-col sm="6" lg="3">
                <b-form-group label="Fecha Límite">
                  <b-form-input type="date" v-model="loan.limitDate" />
                </b-form-group>
              </b-col>

            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!-- Agregar Autopartes -->
    <b-row>
      <b-col sm="12">
        <b-card no-body>
          <b-card-header class="border-b-2 bg-secondary">
            <h4 class="text-white">Agregar autopartes al prestamo</h4>
          </b-card-header>
          <b-card-body class="mt-1">
            <b-row>
              <b-col sm="6" md="4" lg="3">
                <b-form-group label="Categoría">
                  <v-select
                    :options="categories"
                    label="name"
                    v-model="newItem.category"
                    :reduce="(category) => category.id"
                    @input="loadAutoparts"
                  />
                </b-form-group>
              </b-col>

              <b-col sm="6" md="4" lg="3">
                <b-form-group label="Autoparte">
                  <v-select
                    :options="autoparts"
                    label="label"
                    v-model="newItem.autopart"
                    :reduce="(autopart) => autopart"
                  />
                </b-form-group>
              </b-col>

              <b-col sm="6" md="4" lg="2">
                <b-form-group label="Cantidad Solicitada">
                  <b-form-input
                    v-model="newItem.qty"
                    type="number"
                    placeholder="Ingrese cantidad"
                  />
                </b-form-group>
              </b-col>

              <b-col sm="6" md="4" lg="2">
                <b-form-group label="Precio Unitario">
                  <b-form-input
                    v-model="newItem.unitPrice"
                    type="number"
                    placeholder="Ingrese precio unitario"
                  />
                </b-form-group>
              </b-col>

              <b-col sm="4" md="2" class="d-flex align-items-center mt-1">
                <b-button variant="primary" @click="addRow">Agregar</b-button>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!-- Tabla de Detalles -->
    <b-row>
      <b-col sm="12">
        <b-card no-body>
          <b-card-header class="border-b-2 bg-secondary">
            <h4 class="text-white">Detalles del prestamo</h4>
          </b-card-header>
          <b-card-body>
            <b-table
              :items="loanDetails"
              :fields="fields"
              responsive
              hover
              show-empty
              empty-text="No existen detalles"
            >

            <template #cell(state)="data">
              <span :class="getStateClass(data.item.state)">
                {{ data.item.state }}
              </span>
            </template>

            <template #cell(actions)="data">
              <b-button
                v-if="data.item.isNew"
                size="sm"
                variant="danger"
                @click="removeRow(data.index)"
              >
                Eliminar
              </b-button>
            </template>

            </b-table>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>


<script>
import Vue from 'vue'
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import LoanService from "@/services/LoanService";
import StoreService from "@/services/StoresService";
import InventoryService from "@/services/InventoryService";
import UserService from "@/services/UserService";

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

export default {
  directives: {
    'b-tooltip': VBTooltip,
    Ripple
  },
  data() {
    return {
      loan: null,
      loanDetails: [],
      newItem: {
        category: null,
        autopart: null,
        qty: null,
        unitPrice: null,
      },
      stores: [],
      clients: [],
      categories: [],
      autoparts: [],
      fields: [
        { key: "autopart.uniqueCode", label: "Código Único", sortable: true },
        { key: "autopart.originalCode", label: "Codigo original", sortable: true },
        { key: "autopart.AutopartBrand.name", label: "Marca", sortable: false },
        { key: "autopart.description", label: "Autoparte", sortable: false },
        { key: "qty", label: "Cantidad", sortable: false },
        { key: "unitPrice", label: "Precio Unitario" , sortable: false},
        { key: "state", label: "Estado" , sortable: false},
        { key: "actions", label: "Acciones", sortable: false },
      ],
    };
  },
  components: {
    vSelect
  },
  mounted() {
    this.getLoanDetails();
    this.loadStores();
    this.loadClients();

  },
  methods: {
    formatDate(date) {
      if (!date) return "Sin fecha";
      return date.split("T")[0];
    },
    getStateClass(state) {
      switch (state) {
        case 'Pendiente':
          return 'badge badge-warning';
        case 'Facturado':
          return 'badge badge-success';
        case 'Devuelto':
          return 'badge badge-danger';
        default:
          return 'badge badge-secondary';
      }
    },
    async getLoanDetails() {
       const response = await LoanService.getLoanById(this.$route.params.id, this.$store);
       if (response.data) {
         this.loan = response.data.loan;
         if (this.loan.limitDate) {
           this.loan.limitDate = this.formatDate(this.loan.limitDate);
         }
         this.loanDetails = response.data.loanDetails;
       }
       console.log("PRESTAMO", this.loanDetails);
       if (!this.loan.establishmentOriginId) return;
       const resp = await InventoryService.getCategoryxStore(this.loan.establishmentOriginId, this.$store);
       this.categories = resp.data || [];
    },
    async loadStores() {
      const response = await StoreService.getStores("", this.$store);
      this.stores = response.data.rows || [];
    },
    async loadClients() {
      const response = await UserService.getUsers("", this.$store);
      this.clients = response.data.rows.filter((user) => user.role.name === "Cliente");
    },

    async saveLoan() {
    if (!this.loan.documentCode || !this.loan.establishmentOriginId || !this.loan.clientId || !this.loan.limitDate) {
      this.$swal("Error", "Complete todos los campos requeridos antes de guardar.", "error");
      return;
    }

    const formattedLimitDate = new Date(this.loan.limitDate).toISOString();

    const payload = {
      documentCode: this.loan.documentCode,
      establishmentOriginId: this.loan.establishmentOriginId,
      clientId: this.loan.clientId,
      limitDate: formattedLimitDate,
      autoparts: this.loanDetails.map((item) => ({
        autopartId: item.autopart.id,
        qty: parseInt(item.qty),
        unitPrice: parseFloat(item.unitPrice),
        state: item.state,
      })),
    };

    try {
      this.showLoading = true;
      console.log("PAYLOAD: ", payload);
      const response = await LoanService.editUpdateLoan(this.$route.params.id, payload, this.$store); 
      console.log("Respuesta del backend:", response);

      this.$swal("Éxito", "El préstamo ha sido guardado correctamente.", "success");
      this.$router.push("/prestamo"); 
    } catch (error) {
      console.error("Error al guardar el préstamo:", error);
      this.$swal("Error", "Ocurrió un problema al guardar el préstamo.", "error");
    } finally {
      this.showLoading = false;
    }
  },

    async loadAutoparts() {
      const { category } = this.newItem;
      if (!category || !this.loan.establishmentOriginId) return;
      const response = await InventoryService.getStockxCategory(
        this.loan.establishmentOriginId,
        category,
        this.$store
      );
      this.autoparts = response.data.map((item) => ({
        id: item.autopart.id,
        label: `${item.autopart.uniqueCode} - ${item.autopart.description}`,
        qtyAvailable: item.qtyAvailable,
        AutopartBrand:{
          name: item.autopart.AutopartBrand.name,
        }
      }));
    },
    addRow() {
      if (!this.newItem.autopart || !this.newItem.qty || !this.newItem.unitPrice) {
        this.$swal("Error", "Complete todos los campos antes de agregar.", "error");
        return;
      }

      if (this.loanDetails.find((item) => item.autopart.id === this.newItem.autopart.id)) {
        this.$swal("Error", "La autoparte ya está en la lista.", "error");
        return;
      }

      this.loanDetails.push({
        autopart: {
          id: this.newItem.autopart.id,
          uniqueCode: this.newItem.autopart.label.split(" - ")[0],
          description: this.newItem.autopart.label.split(" - ")[1], 
          AutopartBrand:{
            name: this.newItem.autopart.AutopartBrand.name,
          }
        },
        qty: this.newItem.qty,
        unitPrice: this.newItem.unitPrice,
        state: "Pendiente",
        isNew: true, 
      });
      console.log("AUTOPARTES ",this.loanDetails)

      this.newItem = { category: null, autopart: null, qty: null, unitPrice: null };
    },
    removeRow(index) {
      this.loanDetails.splice(index, 1);
    },
  },
};
</script>